import { isDev } from "@/lib/env";

export function DevEnvBanner() {
  if (!isDev) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-black text-xs font-bold text-center py-0.5 select-none pointer-events-none">
      DEV — postcash.kirvps.work
    </div>
  );
}

/** Adds top padding equal to the banner height when in dev mode */
export function DevEnvPadding() {
  if (!isDev) return null;
  return <div className="h-5" />;
}
